import React from "react";
import { FaWhatsapp, FaPhoneAlt } from "react-icons/fa";
import { SiGmail } from "react-icons/si";
import "./ChatBox.css";

const ChatBox = () => {

  const openWhatsApp = () => {
    window.open(
      "https://wa.me/7200039384?text=Hello%20Aerlis%20Gro%20Team",
      "_blank"
    );
  };

  const makeCall = () => {
    window.location.href = "tel:7200039384";
  };

  const openMail = () => {
    const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

    if (isMobile) {
      window.location.href =
        "mailto:info@aerlis.in?subject=Enquiry&body=Hello Aerlis Gro Team";
    } else {
      window.open(
        "https://mail.google.com/mail/?view=cm&fs=1&to=info@aerlis.in",
        "_blank"
      );
    }
  };

  return (
    <div className="chatbox-container">

<div className="chatbox-icon phone" onClick={makeCall}>
        <FaPhoneAlt />
      </div>
      
      <div className="chatbox-icon wa" onClick={openWhatsApp}>
        <FaWhatsapp />
      </div>

      <div className="chatbox-icon gmail" onClick={openMail}>
        <SiGmail />
      </div>

    </div>
  );
};

export default ChatBox;
